<template>
  <input
    class="form-checkbox"
    :class="[
      '[&:is(.error)]:border-danger',
      '[&:is(.error)]:outline-danger',
      '[&:is(.error)]:shadow-none',
      '[&:is(.valid)]:shadow-none',
      { error, valid }
    ]"
    type="checkbox"
    v-model="model"
  />
</template>

<script lang="ts" setup>
defineProps<{
  error?: boolean
  valid?: boolean
}>()

const model = defineModel()
</script>

<style lang="postcss" scoped>
@layer BaseComponents {
  .form-checkbox {
    @apply subtitle-0 border border-primary size-5 rounded text-gray appearance-none;
  }
}
</style>
